export class DirectorResponseEditCommand {
    constructor(
        public readonly VarianceId: string,
        public readonly DirectorResponseId: string,
        public readonly Text: string,
        public readonly ModifiedBy: string,
    ) {}
}
